export function formatSearchTerm(term?: string): string {
  if (!term)
    return ''
  return term.includes(';') ? term : `*${term}*`
}

export function buildQueryParams(params: Record<string, unknown>): Record<string, unknown> {
  const definedParams: Record<string, unknown> = {}
  for (const key in params) {
    const value = params[key]

    if (value === undefined || value === null || value === '')
      continue

    if (typeof value === 'number' && Number.isNaN(value))
      continue

    definedParams[key] = value
  }
  return definedParams
}
